import React from "react";
import showIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-show-table.svg";
import hideIcon from "../../../../../assets/design-revamp-company/company-detail-headers/icon-hide-table.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import { LovableAwareShowHide } from "../../../ProductDetailsLCA/components/LovableFlowControls";

export const ShowHide = ({ show: externalShow, setShow: externalSetShow }) => {
  const [internalShow, setInternalShow, isPDFMode] = usePDFShowHide(false, {
    forceShowInPDF: true,
  });

  const show = externalShow !== undefined ? externalShow : internalShow;
  const setShow = externalSetShow || setInternalShow;

  const handleToggle = () => {
    if (!isPDFMode) {
      setShow(!show);
    }
  };

  return (
    <LovableAwareShowHide
      isOpen={show}
      onToggle={handleToggle}
      legacyShowSrc={showIcon}
      legacyHideSrc={hideIcon}
      size="lg"
      imgClassName="show-hide-icon"
      disabled={isPDFMode}
    />
  );
};
